import styled from 'styled-components/macro'
import breakpoints from 'assets/stylesheet'

const SearchResultTitle = styled.h1`
  font-family: 'Open Sans', sans-serif;
  color: #4a4a4a;
  font-size: 28px;
  margin-bottom: 13px;
  @media (max-width: ${breakpoints.bpPhonePx}) {
    font-size: 20px !important;
  }
  span {
    margin-right: 20px;
  }
`

export default SearchResultTitle
